import React, { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import useStyledReportColumns from "../useStyledReportColumns";

export default function AllTimeGrossProfit({ centerName }) {
  const [allGrossProfitReport, setAllGrossProfitReport] = useState([]);
  useEffect(() => {
    const fetchAllGrossProfitReport = async () => {
      try {
        const response = await axios.get(
          `${config.baseUrl}/budget/all_time_gross_profit/`,
          {
            headers: authHeader(),
            params: {
              center_name: centerName,
            },
          }
        );
        setAllGrossProfitReport(response?.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchAllGrossProfitReport();
  }, [centerName]);

  const columns = useStyledReportColumns([
    {
      title: "Center",
      dataIndex: "center",
    },

    {
      title: "Total Purchase",
      render: (item) => Number(item?.purchases?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Total Sales",
      render: (item) => Number(item?.sales?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Gross Profit/Loss",
      render: (item) => Number(item?.gross_profit?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Gross Margin(%)",
      render: (item) => item?.gross_profit_margin?.toFixed(2),
    },
    {
      title: "Expense",
      render: (item) => Number(item?.expenses?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Net Profit/Loss",
      render: (item) => Number(item?.net_profit?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Net Margin(%)",
      render: (item) =>
        item?.net_profit_percentage?.toFixed(2),
    },
  ]);

  return (
    <div>
      <Table
        className="mt-4 shadow-sm mb-3"
        size="small"
        columns={columns}
        dataSource={allGrossProfitReport}
        pagination={false}
        rowKey={(item) => item?.id}
      />
    </div>
  );
}
